var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.744,
    height: 39.744,
    viewBox: "0 0 39.744 39.744",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6992",
    "data-name": "Group 6992",
    transform: "translate(-504 -1093)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1013",
    "data-name": "Ellipse 1013",
    cx: 19.372,
    cy: 19.372,
    r: 19.372,
    transform: "translate(504.5 1093.5)",
    fill: "#fff",
    stroke: "#e7873c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "expenses_copy",
    "data-name": "expenses copy",
    transform: "translate(512 1101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16036",
    "data-name": "Path 16036",
    d: "M30.426,57.894h-.287c-1.134,0-2.27.026-3.4-.008a1.856,1.856,0,0,0-2.115,1.762,5.473,5.473,0,0,0,.074,2.308,1.736,1.736,0,0,0,1.847,1.421c1.281,0,2.562,0,3.836,0,.019.019.038.032.038.043,0,.832.042,1.666-.009,2.5a1.918,1.918,0,0,1-1.942,1.768c-1.477.008-2.955,0-4.431,0H11.794A1.972,1.972,0,0,1,9.66,65.553V55.71A1.971,1.971,0,0,1,11.8,53.58H28.3a1.971,1.971,0,0,1,2.128,2.14C30.426,56.437,30.426,57.154,30.426,57.894Z",
    transform: "translate(-9.66 -44.57)",
    fill: "#ae2b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16037",
    "data-name": "Path 16037",
    d: "M27.65,22.482c.617-.542,1.179-1.036,1.744-1.528q2.485-2.177,4.968-4.355a1.145,1.145,0,0,1,1.321-.279,1.206,1.206,0,0,1,.721,1.2c0,.464-.008.93,0,1.394a.28.28,0,0,1-.187.3Q33.014,20.8,29.811,22.4a.549.549,0,0,1-.226.077C28.961,22.484,28.343,22.482,27.65,22.482Z",
    transform: "translate(-24.255 -14.253)",
    fill: "#ae2b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16038",
    "data-name": "Path 16038",
    d: "M96.148,80.582c.776,0,1.549,0,2.325,0a1.175,1.175,0,0,1,1.234,1.227c0,.489,0,.979,0,1.468A1.173,1.173,0,0,1,98.491,84.5q-2.324.006-4.649,0a.945.945,0,0,1-1.059-.811,4.654,4.654,0,0,1,0-2.3.946.946,0,0,1,1.064-.806Zm.423,1.961A1.566,1.566,0,1,0,94.995,84.1,1.572,1.572,0,0,0,96.57,82.542Z",
    transform: "translate(-76.982 -66.475)",
    fill: "#ae2b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16039",
    "data-name": "Path 16039",
    d: "M106.742,13.277c-.519-.391-1.026-.77-1.572-1.179a2.942,2.942,0,0,0,1.315-1.3,2.762,2.762,0,0,0,.242-1.832c-.26,0-.521.017-.777-.008a.481.481,0,0,1-.338-.166.4.4,0,0,1,.07-.343c.564-.779,1.14-1.551,1.717-2.321a.584.584,0,0,1,1.017,0c.577.77,1.153,1.542,1.717,2.321a.427.427,0,0,1,.072.364c-.049.089-.223.138-.345.149-.242.023-.489.006-.757.006A5.2,5.2,0,0,1,106.742,13.277Z",
    transform: "translate(-87.148 -5.829)",
    fill: "#ae2b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16040",
    "data-name": "Path 16040",
    d: "M56.333,34.287H47.91c.072-.049.109-.081.153-.1q3.269-1.633,6.538-3.263a1.171,1.171,0,0,1,1.762,1.1c0,.734,0,1.468,0,2.2A.277.277,0,0,1,56.333,34.287Z",
    transform: "translate(-40.692 -26.062)",
    fill: "#ae2b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16041",
    "data-name": "Path 16041",
    d: "M101.81,88.386a.783.783,0,1,1,.776-.785A.791.791,0,0,1,101.81,88.386Z",
    transform: "translate(-83.78 -71.537)",
    fill: "#ae2b30"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/Icon1.a6dfd086086fc11795b5a9f6f07b5988.svg";
export { ForwardRef as ReactComponent };